/**
 * Get the selected tab element.
 * @param nodes The nodes to enumerate.
 * @returns The selected tab element or null if none selected.
 */
export function getSelectedTabElement(nodes: ReadonlyArray<Node>): HTMLElement | null {
  for (const node of nodes) {
    if (!(node instanceof HTMLLIElement)) continue;
    if (node.matches(".tab.selected")) return node;
  }

  return null;
}
